(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["healux-gifting-products"] && !Shopify.designMode) return;
  try {
    
(() => {
  let giftProductId = null;
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const quickAdd = target?.closest('quick-add-component');
    if (!quickAdd) return;
    const card = quickAdd.closest('.healux-gift-card');
    giftProductId = card ? card.dataset.productId : null;
  }, true);
  function isGiftModalForm(form) {
    if (!(form instanceof HTMLFormElement) || !form.closest('quick-add-dialog')) return false;
    const productForm = form.closest('product-form-component');
    return Boolean(giftProductId && productForm?.dataset.productId === giftProductId);
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!isGiftModalForm(form)) return;
    for (const [name, value] of Object.entries({
      'properties[Gift packing]': 'Included'
    })) {
      let field = form.elements.namedItem(name);
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = name;
        form.append(field);
      }
      field.value = value;
    }
  }, true);
  document.addEventListener('formdata', (event) => {
    if (!isGiftModalForm(event.target)) return;
    event.formData.set('properties[Gift packing]', 'Included');
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
